(() => {
  const selector = '[data-stemma-drag-slider]';

  const initializeSlider = (slider) => {
    if (slider.dataset.stemmaDragReady === 'true') return;
    slider.dataset.stemmaDragReady = 'true';

    let activePointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let hasMoved = false;

    const finishDrag = (event) => {
      if (activePointerId === null) return;
      if (event?.pointerId !== undefined && event.pointerId !== activePointerId) return;

      const pointerId = activePointerId;
      activePointerId = null;
      slider.classList.remove('is-dragging');

      if (slider.hasPointerCapture?.(pointerId)) {
        slider.releasePointerCapture(pointerId);
      }

      if (!hasMoved) return;

      const slides = Array.from(slider.querySelectorAll('.stemma-story__slide'));
      if (!slides.length) return;

      const closestSlide = slides.reduce((closest, slide) => {
        const closestDistance = Math.abs(closest.offsetLeft - slider.scrollLeft);
        const slideDistance = Math.abs(slide.offsetLeft - slider.scrollLeft);
        return slideDistance < closestDistance ? slide : closest;
      });

      slider.scrollTo({ left: closestSlide.offsetLeft, behavior: 'smooth' });
    };

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;

      activePointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      hasMoved = false;
      slider.classList.add('is-dragging');
      slider.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    });

    slider.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) return;

      const distance = event.clientX - startX;
      if (Math.abs(distance) > 3) hasMoved = true;
      if (!hasMoved) return;

      slider.scrollLeft = startScrollLeft - distance;
      event.preventDefault();
    });

    slider.addEventListener('pointerup', finishDrag);
    slider.addEventListener('pointercancel', finishDrag);
    slider.addEventListener('lostpointercapture', finishDrag);
    slider.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const initializeAll = (root) => {
    root.querySelectorAll(selector).forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
